var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex items-center justify-center text-gray-400"},[_c('icon',{attrs:{"name":"Loading","size":"1.5em"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }